import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const MasterFoodLibraryHeader = ({ section, updateState, search }) => {
  const { t } = useTranslation("coaching-portal");
  const ns = "masterFoodLibraryScreen";
  const isExternal = section === "external";
  const sectionLabel = {
    food: t(`${ns}.food`),
    meal: t(`${ns}.meals`),
    external: t(`${ns}.externalFood`),
  }[section];

  const urlBase = `/actions/refresh/?modal[type]=`;
  const finalUrl =
    section === "food"
      ? `${urlBase}handle-meal-planner-food`
      : `${urlBase}build-meal`;

  return (
    <div className="master-food-library-header">
      <header className="header-master-food-library">
        <hgroup>
          <div className="title-container">
            <SvgIcon
              src="/img/new-icons/back-button.svg"
              onClickFn={() => {
                window.location.href = `${origin}/coaching-portal/all-templates?owner=coach&tabView=meal-plans-tab&templateView=meal-plans`;
              }}
              classNames="cursor-pointer"
            />
            <h3>{t(`${ns}.pageTitle`)}</h3>
          </div>
          <p className="p4 opacity-70">
            {isExternal
              ? t(`${ns}.external.description`)
              : t(`${ns}.description`)}
          </p>
        </hgroup>
        {!isExternal && (
          <a role="button" data-button-type="primary" href={finalUrl}>
            <img src="/img/new-icons/add.svg" alt={t(`${ns}.addNewAlt`)} />
            {t(`${ns}.addNewSection`, { section: sectionLabel })}
          </a>
        )}
      </header>
      <div className="options">
        {!isExternal && (
          <input
            type="search"
            name="search"
            placeholder={t(`${ns}.searchPlaceholder`, {
              section: sectionLabel,
            })}
            value={search}
            onChange={(e) => updateState({ search: e.target.value })}
            autoComplete="off"
            data-expandable
          />
        )}
        <button
          data-button-type={section === "food" ? "outline" : "secondary"}
          onClick={() => updateState({ section: "food" })}
        >
          <span>{t(`${ns}.food`)}</span>
        </button>
        <button
          data-button-type={section === "meal" ? "outline" : "secondary"}
          onClick={() => updateState({ section: "meal" })}
        >
          <span>{t(`${ns}.meals`)}</span>
        </button>
        <button
          data-button-type={isExternal ? "outline" : "secondary"}
          onClick={() => updateState({ section: "external" })}
        >
          <span>{t(`${ns}.externalFood`)}</span>
        </button>
      </div>
    </div>
  );
};

MasterFoodLibraryHeader.propTypes = {
  section: PropTypes.string,
  search: PropTypes.string,
  updateState: PropTypes.func,
};

export default MasterFoodLibraryHeader;
